export default function errorLogger(error) {
    if (!isPRODUCTION) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
}
